import type { SVGProps } from "react";

export default function SortingDescendingIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M10 3.3335V16.6668M10 16.6668L15 11.6668M10 16.6668L5 11.6668"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
